import type { Lang } from '@dia/i18n';

/**
 * Which language a person sees before they have chosen one. Owners and managers
 * read English; the crew read Spanish. Anyone who flips the toggle keeps their
 * choice (the i18n store remembers it); this only decides the starting point.
 */
export function defaultLangFor(role: 'crew' | 'manager' | 'owner'): Lang {
  return role === 'crew' ? 'es' : 'en';
}

const KEY = 'dia.ops.lang.default';

/**
 * The default last used on this phone, read before anyone has signed in again,
 * so a manager's phone does not open in Spanish and flip to English a moment
 * later. A phone nobody has signed in on starts in Spanish.
 */
export function storedDefaultLang(): Lang {
  try {
    return globalThis.localStorage?.getItem(KEY) === 'en' ? 'en' : 'es';
  } catch {
    return 'es';
  }
}

export function rememberDefaultLang(lang: Lang): void {
  try {
    globalThis.localStorage?.setItem(KEY, lang);
  } catch {
    // Private mode or a full disk: the default is worked out again next sign in.
  }
}
